export default "__VITE_ASSET__BNn97Met__"